export default "../media/bg_approach_1_large.b4621a07a18e15d14aa3ee3302fdad0a.jpeg";